import { memo } from "react"
import { TableCell, TableRow } from "./table"
import { Checkbox } from "./checkbox"
import { TableColumnConfig, ColumnType } from "@/types/table"
import { formatCurrency, formatDate, formatPercentage } from "@/lib/formatting"

export interface TableRowContentProps<T> {
  item: T
  isSelected?: boolean
  onCheckboxChange?: (id: number, checked: boolean) => void
  language?: 'en-CA' | 'fr-CA'
  columnsConfig: TableColumnConfig<T>[]
  showCheckbox?: boolean
  className?: string
  clickable?: boolean
  onRowClick?: () => void
}

function TableRowContent<T>({ 
  item,
  isSelected,
  onCheckboxChange,
  language,
  columnsConfig,
  showCheckbox = false,
  className = '',
  clickable = false,
  onRowClick
}: TableRowContentProps<T>) {
  const itemId = (item as any).id

  return (
    <TableRow 
      className={`${isSelected ? '!bg-[#e6e6e6]' : 'even:bg-white odd:bg-[#f5f5f5]'} hover:bg-[#dfdfdf] ${className} ${clickable ? 'cursor-pointer' : ''}`}
      onClick={clickable && onRowClick ? onRowClick : undefined}
    >
      {showCheckbox && itemId && onCheckboxChange && (
        <TableCell className="p-0 w-[50px] border-r-[1px] border-r-[#dddddd] relative">
          <div className="px-4 py-2">
            <Checkbox checked={isSelected} onCheckedChange={(checked) => onCheckboxChange(itemId, !!checked)} />
          </div>
        </TableCell>
      )}
      {columnsConfig.map((col) => (
        <TableCell key={String(col.key)} className={`p-0 ${col.width} border-r-[1px] border-r-[#dddddd] relative`}>
          <div className="px-4 py-2">
            {col.customRender ? col.customRender(item) : 
              col.displayValue ? col.displayValue(item) :
              col.type === 'date' ? formatDate(String(item[col.key as keyof T] || ''), 'MMM d, yyyy', language) :
              col.type === 'currency' ? formatCurrency(item[col.key as keyof T] as number) :
              col.type === 'percentage' ? formatPercentage(item[col.key as keyof T] as number) :
              col.type === 'number' ? String(item[col.key as keyof T] || '') :
              String(item[col.key as keyof T] || '')
            }
          </div>
        </TableCell>
      ))}
    </TableRow>
  )
}

TableRowContent.displayName = 'TableRowContent'

export default memo(TableRowContent) as typeof TableRowContent 